import { type NavType } from "~/content/navLinks";
import { useActivePath } from "~/app/utils/navHelper";
import Link from "next/link";

type MenuItem = NavType;

export interface MenuProps extends NavType {
  items?: MenuItem[];
}

const FlyoutMenus = ({ name, href, items }: MenuProps) => {
  const checkActivePath = useActivePath();

  return (
    <div className="mx-auto flex w-full items-center">
      <div className="group relative cursor-pointer">
        <div className="flex items-center justify-between space-x-5">
          <Link
            href={href}
            className={`menu-hover text-base hover:text-orange focus:text-orange xl:text-lg ${checkActivePath(href) ? "text-orange" : "text-white"}`}
          >
            {name}
          </Link>
        </div>

        <div className="invisible absolute z-50 flex w-full flex-col py-1 shadow-xl group-hover:visible">
          {/* menu background: bg-gradient-to-t from-gradient-blue2/85 to-gradient-blue1/85 */}
          <div className="w-72 shrink rounded-lg bg-gradient-blue2/90 p-4 text-base leading-6 text-white shadow-lg ring-1 ring-gray-900/5 xl:text-lg">
            {items?.map((item) => (
              <Link
                key={item.name}
                href={item.href}
                className={`block p-2 hover:text-green-light focus:text-green-light ${checkActivePath(item.href, true) ? "text-green" : "text-white"}`}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlyoutMenus;
